import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { lazy, Suspense } from 'react';

import KnowledgeBaseIconLink from './KnowledgeBaseIconLink';
import Notifications from './Notifications/Notifications';
import { ProfileDropdown } from './ProfileDropdown';
import { SettingsIconLink } from './SettingsIconLink';
import { useAppSelector } from 'src/app/store/hooks';
import { AddATripFlow } from 'src/features/add-trip';
import { useShouldShowRideOrderingPortalFeatures } from 'src/features/rideOrderingPortal/useShouldShowRideOrderingPortalFeatures';
const ChatBubble = lazy(() => import('./ChatBubble'));

export function RightNav() {
  const shouldHideChatBubble = useShouldShowRideOrderingPortalFeatures();
  const sendbirdAccessToken = useAppSelector(
    (state) => state.chat.sendbirdAccessToken
  );

  return (
    <div className="z-10 flex items-center gap-1">
      <AddATripFlow />
      <div className="mx-2 flex items-center gap-1">
        <KnowledgeBaseIconLink />
        <SettingsIconLink />
        {!shouldHideChatBubble && sendbirdAccessToken && (
          <Suspense fallback={<LoadingIndicator />}>
            <ChatBubble />
          </Suspense>
        )}
        <Notifications />
      </div>
      <ProfileDropdown />
    </div>
  );
}
